/**
* Video Controls Module
*/

class VideoControls {
  #controls;
  #video;
  #togglePause;

  /**
  * @constructor
  * @param {HTMLElement} element element to bind to
  */
  constructor(element) {
    this.#controls = element;

    const targetId = this.#controls.getAttribute('data-target');
    this.#video = document.querySelector(targetId);

    if (this.#video) {
      this.#togglePause = this.#controls.querySelector('.js-video-toggle-pause');

      this.#bindEvents();
    }
  }

  /**
   * Binds the necessary event listeners
   */
  #bindEvents() {
    if (this.#togglePause) {
      this.#togglePause.addEventListener('click', this.#handleTogglePauseClick.bind(this));
    }
  }

  /**
   * Handles the click event on the play toggle button
   * @param {Event} event - The click event
   */
  #handleTogglePauseClick(event) {
    event.preventDefault();

    if (this.#video.paused) {
      this.#video.play();
      this.#controls.classList.remove('paused');
      this.#togglePause.ariaPressed = 'false';
    } else {
      this.#video.pause();
      this.#controls.classList.add('paused');
      this.#togglePause.ariaPressed = 'true';
    }
  }


  static init() {
    const videoHolder = document.querySelectorAll('.js-video-controls');

    videoHolder.forEach(el => {
      new VideoControls(el);
    });
  }
}

export default VideoControls;
